module.exports = __webpack_public_path__ + "img/wishlist-2@2x.2a99b77.webp";